import { axios } from '@/utils/request'

const api = {
  noticeDingTalkGroupMessage: '/sso/dingTalk/noticeDingTalkGroupMessage',
  dingTalkLoginAutoRegister: '/sso/dingTalk/dingTalkLoginAutoRegister' // 钉钉扫码
}

export default api
export const noticeDingTalkGroupMessage = params => axios.post(api.noticeDingTalkGroupMessage, params)
export const dingTalkLoginAutoRegister = async params => axios.post(api.dingTalkLoginAutoRegister, Object.assign({ systemCode: 'SSO_SYS_USER' }, params))
